module.exports = __webpack_public_path__ + "img/settings.90470610.svg";